import React from 'react';
import { Container, Row } from 'reactstrap';
import ResizableDataTable from './components/ResizableReactTable';
import CreateTableData from './CreateData';

const ResizableTable = ({ data }) => {
  const reactTableData = CreateTableData(data);

  return (
    <Container>
      <Row>
        <ResizableDataTable reactTableData={reactTableData} />
      </Row>
    </Container>
  );
};

export default ResizableTable;
